/* eslint-disable */
import { register } from "register-service-worker";

register(`${process.env.BASE_URL}service-worker.js`, {
  ready() {
    console.log(
      "App is being served from cache by a service worker.\n" +
        "For more details, visit https://goo.gl/AFskqB"
    );
    // if (localStorage.getItem("employerapp-version") !== "05112023") {
    //   caches.keys().then(function (names) {
    //     for (let name of names) {
    //       caches.delete(name);
    //       console.log("name", name);
    //     }
    //   });
    //   localStorage.setItem("employerapp-version", "05112023");
    // }
    caches.delete('theincircle_employer-precache-v2-https://www.theincircle.com/employerzone/');
  },
  registered() {
    // console.log('Service worker has been registered.')
  },
  cached() {
    // console.log('Content has been cached for offline use.')
  },
  updatefound() {
    // console.log('New content is downloading.')
  },
  updated() {
    // console.log('New content is available; please refresh.')
    console.log("New content is available: Please refresh.");
    caches.delete('theincircle_employer-precache-v2-https://www.theincircle.com/employerzone/');
  },
  offline() {
    // console.log('No internet connection found. App is running in offline mode.')
  },
  error(error) {
    console.error("Error during service worker registration:", error);
  },
});
